import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';
import {CommonUtilitiesService} from '../common-utilities.service'
@Injectable({
  providedIn: 'root'
})
export class CreateTicketService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService,
    private commonUtilitiesService:CommonUtilitiesService
  ) { }
 
  /**
   * Description: Método que llama el servicio web de creación de ticket
   * Autor: Diego Diaz
   * @param jsonData parámetros de entrada del servicio
   * @return confirmación de la creación de la solicitud
   */
  createTicketRequest(jsonData) {
    const newjsonData = this.commonUtilitiesService.encrypt(jsonData);
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_TICKET_REQUEST, newjsonData);
  }

    
  /**
   * Description: Método que llama el servicio web de obtener listado de categorias de tickets
   * Autor: Diego Diaz
   * @param N/A
   * @return Listado de categorias
   */
  getCategories() {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_TICKET_GET_CATEGORIES, "");
  }
}
